























import { Component, Prop, Vue } from "vue-property-decorator";
import { PraesidiumYear } from "@/api/models/PraesidiumYear";
import { User } from "@/api/models/User";
import { JsonLink } from "@/types/JsonLink";
import PraesidiumNavigation from "@/components/praesidium/PraesidiumNavigation.vue";
import PraesidiumOntgroend from "@/components/praesidium/PraesidiumOntgroend.vue";
import PraesidiumCard from "@/components/praesidium/PraesidiumCard.vue";
import { PraesidiumRole } from "@/api/models/PraesidiumRole";

@Component({
    components: { PraesidiumCard, PraesidiumOntgroend, PraesidiumNavigation }
})
export default class Praesidium extends Vue {
    /**
     * Current praesidium year specified as a string of: "start-end"
     * Should be passed by the router.
     */
    @Prop()
    currentPraesidiumYear: string;

    /**
     * Get list of praesidium years.
     */
    get praesidiumYears(): Array<PraesidiumYear> {
        return require("@/api/content/praesidium/praesidium_years.json");
    }

    /**
     * Get current praesidium year.
     * If an URL is present, use the requested year.
     * Otherwise use the current year.
     */
    get praesidiumYear(): PraesidiumYear {
        // If an URL is present, use the requested year.
        if (this.currentPraesidiumYear) {
            const year =
                this.praesidiumYears.find(year => this.currentPraesidiumYear === `${year.start}-${year.end}`) ??
                this.praesidiumYears[0];

            // Only return the year when it exists.
            // Otherwise show the default fallback: the current praesidium year.
            if (year) {
                return year;
            }
        }

        // Otherwise use the current year.
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        let startYear = currentYear;

        // 8 is the internal representation for september.
        // Once we are in september, the current year becomes the start year.
        // Otherwise the previous year is the start year.
        if (currentMonth < 8) {
            startYear -= 1;
        }
        
        const year = this.praesidiumYears.find(year => year.start === startYear) ?? this.praesidiumYears[0];

        // Rewrite the URL.
        this.$router.push({
            name: "Praesidium",
            params: {
                currentPraesidiumYear: `${year.start}-${year.end}`
            }
        });

        return year;
    }

    /**
     * Get the current active praesidium users.
     */
    get praesidium(): Array<User> {
        return (
            this.getLinkUsers(this.praesidiumYear.praesidium)
                // Sort the users based on their role.
                .sort((user1, user2) => this.getUserRole(user1).order - this.getUserRole(user2).order)
        );
    }

    /**
     * Get the role for a given user.
     * @param user User
     */
    getUserRole(user: User): PraesidiumRole {
        const entry = user.praesidium.find(entry => entry.year === this.praesidiumYear.start);

        // Make sure the entry is present.
        if (!entry) {
            throw new Error(
                `No praesidium entry for user '${user.firstname} ${user.lastname}' for year ${this.praesidiumYear.start}`
            );
        }

        return require("@/api/content/praesidium/roles/" + entry.role);
    }

    /**
     * Get the user for a given JSON link.
     * @param link
     */
    getUser(link: JsonLink<User>): User {
        return require("@/api/content/users/" + link);
    }

    /**
     * Get a list of users for a given JSON link collection.
     */
    getLinkUsers(links: Array<JsonLink<User>>): Array<User> {
        return links ? links.map(user => this.getUser(user)) : [];
    }
}
